<script>
	//Services
	import { format } from 'svelte-i18n';
	//Design system compoennts
	import { Button, ButtonGroup, Text } from '@Shelly/shelly-design-system';
	//Design system helpers
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let enabled, description, request;
</script>

<div class="d-flex align-items-center">
	<ButtonGroup
		id="buttongroup-xhe1hg1"
		aria-label={$format('label_notification', { default: 'Notification' })}
		bgColorType="light"
		class="mr-s flex-shrink-0"
	>
		<Button class={classMap({ active: enabled })} size="m" on:click={() => request(1)}
			>{$format('enable')}</Button
		>
		<Button class={classMap({ active: !enabled })} size="m" on:click={() => request(0)}
			>{$format('disable')}</Button
		>
	</ButtonGroup>
	<Text styleType="body-small">{description}</Text>
</div>
